<template>
  <div>
    <Nav ref="myheader" :rType="2"></Nav>
    <div class="downApps">
      <full-page :options="options" ref="fullpage">
        <div class="section">
          <div class="downloadApps slide1Box" :class="pageIndex == 1?'animalfadein':'animalfadeout'">
            <div class="slide1Title">
              <img src="@/assets/img/slide1_title.png" alt="" srcset="">
            </div>
            <div class="slide1Cnt">
              <div class="leftBox">
                <img src="@/assets/img/slide1_video.png" alt="" srcset="">
                <a href="https://online-lz.oss-accelerate.aliyuncs.com/obs/release/lzLiveSetup.exe"> <img
                    class="BtnsDowns" src="@/assets/img/slide1_btn.png" alt="" srcset=""></a>
              </div>
              <div class="rightBox">
                <img src="@/assets/img/slide1_app.png" alt="" srcset="">
              </div>
            </div>
            <div class="moreNext">
              <div>成为龙珠主播，更多好处等你来发现</div>
              <img @click="next"
                src="data:image/png;base64,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"
                alt="" srcset="">
            </div>
          </div>
        </div>
        <div class="section">
          <div class="downloadApps slide2Box" :class="pageIndex == 0?'animalfadein':'animalfadeout'">
            <div class="slide2Title">
              <img src="@/assets/img/slide2_titles.png" alt="" srcset="">
            </div>
            <div class="slide2Cnt">
              <div class="slide2CntItem">
                <img style="width: 229px;height: 188px;" src="@/assets/img/slide2_diannao.png" alt="" srcset="">
                <div class="downTitle">下载直播工具</div>
                <div class="goDownloads"><a
                    href="https://online-lz.oss-accelerate.aliyuncs.com/obs/release/lzLiveSetup.exe"><span>去下载</span>
                    <img src="@/assets/img/rights.png" alt="" srcset=""></a></div>
              </div>
              <div class="slide2CntItem">
                <img style="width: 189px;height: 188px;" src="@/assets/img/slide2_ren.png" alt="" srcset="">
                <div class="downTitle">实名认证成为主播</div>
                <div class="goDownloads"> <a @click="navRule"><span>{{userInfo && userInfo.identity == 2 ?'去开播':'去认证'}}</span> <img src="@/assets/img/rights.png" alt=""
                      srcset=""></a> </div>
              </div>
              <div class="slide2CntItem">
                <img style="width: 188px;height: 188px;" src="@/assets/img/slide2_dui.png" alt="" srcset="">
                <div class="downTitle">开播成功</div>
                <div class="goDownloads" style="color: #999;">完成认证后即可开播</div>
              </div>
            </div>
          </div>
        </div>
      </full-page>
    </div>
    <div>
    </div>
  </div>
</template>
<script>
  import Nav from "../component/Nav.vue";
  export default {
    components: {
      Nav
    },
    data() {
      return {
        userInfo:{},
        pageIndex: '',
        times: null,
        options: {
          // onLeave:this.onLeave, // 滚动前的回调
          // 为每个section设置背景色
          // sectionsColor: ["#f00","#0f0","#00f"],
          //用来控制slide幻灯片的箭头，设置为false，两侧的箭头会消失
          //controlArrows: false,
          //每一页幻灯片的内容是否垂直居中
          verticalCentered: false,
          //字体是否随着窗口缩放而缩放
          resize: true,
          //页面滚动速度
          scrollingSpeed: 400,
          //定义锚链接，用户可以快速打开定位到某一页面；不需要加"#"，不要和页面中任意的id和name相同
          //anchors: ["page1","page2","page3"],
          //是否锁定锚链接
          //lockAnchors: true,
          //定义section页面的滚动方式，需要引入jquery.easings插件
          //easing:,
          //是否使用css3 transform来实现滚动效果
          css3: false,
          //滚动到最顶部后是否连续滚动到底部
          //loopTop: true,
          //滚动到最底部后是否连续滚动到顶部
          //loopBottom: true,
          //横向slide幻灯片是否循环滚动
          //loopHorizontal: false,
          //是否循环滚动，不会出现跳动，效果很平滑
          //continuousVertical: true,
          //是否使用插件滚动方式，设为false后，会出现浏览器自带的滚动条，将不会按页滚动
          //autoScrolling: false,
          //是否包含滚动条，设为true，则浏览器自带的滚动条会出现，页面还是按页滚动，但是浏览器滚动条默认行为也有效
          //scrollBar: true,
          //设置每个section顶部的padding，当我们要设置一个固定在顶部的菜单、导航、元素等时使用
          //paddingTop: "100px",
          //设置每个section底部的padding，当我们要设置一个固定在底部的菜单、导航、元素等时使用
          //paddingBottom: "100px",
          //固定的元素，为jquery选择器；可用于顶部导航等
          //fixedElements: ".nav",
          //是否可以使用键盘方向键导航
          //keyboardScrolling: false,
          //在移动设置中页面敏感性，最大为100，越大越难滑动
          //touchSensitivity: 5,
          //设为false，则通过锚链接定位到某个页面不再有动画效果
          //animateAnchor: false,
          //是否记录历史，可以通过浏览器的前进后退来导航
          //recordHistory: true,
          //绑定菜单，设定相关属性和anchors的值对应后，菜单可以控制幻灯片滚动
          //menu: '.nav',
          //是否显示导航，设为true会显示小圆点作为导航
          navigation: true,
          //导航小圆点的位置，可以设置为left或者right
          navigationPosition: 'right',
          //鼠标移动到小圆点上时显示出的提示信息
          //navigationTooltips: ["第一页","第二页","第三页"],
          //是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
          //showActiveTooltip: true,
          //是否显示横向幻灯片的导航
          //slidesNavigation: true,
          //横向幻灯片导航的位置，可以为top或者bottom
          //slidesNavPosition: bottom,
          //内容超过满屏时是否显示滚动条，需要jquery.slimscroll插件
          //scrollOverflow: true,
          //section选择器
          //sectionSelector: ".section",
          //slide选择器
          //slideSelector: ".slide"
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          afterLoad: this.afterLoad,
          scrollOverflow: true,
          scrollBar: false,
          menu: '#menu',
          // navigation: true,
          // anchors: ['page1', 'page2', 'page3'],
          // sectionsColor: ['#ba5be9', '#ff5f45', '#0798ec', '#fec401', '#1bcee6', '#ee1a59', '#2c3e4f', '#ba5be9',
          //   '#b4b8ab'
          // ]
        }
      }
    },
    mounted() {
      // 判断是否是主播
      this.$store.dispatch('getUserInfoData', 2).then((result) => {
        console.log('获取用户信息1', result);
        this.userInfo = result.userInfo;

      });
    },
    methods: {
      afterLoad(val) {
        this.times = setTimeout(() => {
          if (this.pageIndex == '') {
            this.pageIndex = 1
            return
          }
          this.pageIndex = val.index;
          console.log('回调', this.pageIndex, val);
        }, 100)

      },
      navRule() {
        if (!localStorage.getItem('token')) {
          this.$nextTick(() => {
            this.$refs.myheader.Longin()
          })
          return
        }

        if (this.userInfo && this.userInfo.identity == 2) {
          this.$NewRouter(`/v2/my/showset`);
          // this.$router.push({
          //   path: '/tianjiazhiboyuan',
          //   query: {
          //     id: 8,
          //     tab: 2,
          //   }
          // })
        } else {
          this.$NewRouter(`/v2/my/anchor/join`);
          // this.$router.push({
          //   path: '/anchor',
          // })
        }

      },
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionDown();
      }
    }
  }
</script>
<style lang="scss">
  a {

    text-decoration: none;

    color: #colorname;

  }

  @keyframes animals {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 0;
    }

    50% {
      -webkit-transform: translateY(10px);
      transform: translateY(10px);
      opacity: 1;
    }

    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 0;
    }
  }

  @keyframes fadeRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
  }

  @keyframes fadeOutRight {
    0% {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);

    }

    100% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
  }

  @keyframes fadeLeft {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
  }

  @keyframes fadeTop {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
  }

  @keyframes fadeBottom {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
  }

  .moreNext {
    position: absolute;
    bottom: 50px;
    text-align: center;

    img {
      cursor: pointer;
      margin-top: 6px;
      animation: animals 2s infinite;
      width: 27px;
      height: 25px;
    }
  }

  .downApps {
    background-image: url('~@/assets/img/downbg.png');
    // background-image: url(https://oss.ansongqiubo.com/assets/person/downloads.png);
    position: relative;
    background-attachment: fixed;
    background-repeat: no-repeat;
    // background-position: center;
    background-size: cover;
    float: left;
  }
  .downloadApps {
    width: 100vw;
    height: 100%;
    transform: scale(.85);
  }
  .animalfadeout {
    // .leftBox{
    //   opacity: 1 !important;
    //   img {
    //     animation:fadeLeft 1s ease-out alternate;
    //   }
    // }
    // .rightBox {
    //   opacity: 1 !important;
    //   img {
    //     animation:fadeOutRight 1s ease-in-out alternate;
    //   }
    // }
  }

  .animalfadein {

    .slide1Title,
    .slide2Title {
      opacity: 1 !important;

      img {
        animation: fadeTop 1s ease-in-out;
      }

    }

    .slide2Cnt {
      opacity: 1 !important;
      animation: fadeBottom 1s ease-in-out;
    }

    .leftBox {
      opacity: 1 !important;

      img {
        animation: fadeLeft 1s ease-out;
      }
    }

    .rightBox {
      opacity: 1 !important;

      img {
        animation: fadeRight 1s ease-in-out;
      }
    }
  }

  .slide1Box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    .slide1Cnt {
      margin-top: 17px;
      display: flex;

      .leftBox {
        opacity: 0;
        width: 577px;
        // height: 443px;
        display: flex;
        margin-right: 55px;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .BtnsDowns {
          margin-top: 59px;
          width: 182px;
          height: 56px;
          cursor: pointer;

          img {
            width: 182px;
            height: 56px;
          }
        }

        img {
          width: 577px;
          height: 443px;
        }

      }

      .rightBox {
        opacity: 0;
        transform: translateY(33px);
        width: 588px;
        height: 497px;

        img {
          width: 588px;
          height: 497px;
        }
      }
    }

    .slide1Title {
      opacity: 0;

      img {
        width: 805px;
        height: 177px;
      }

    }
  }

  .slide2Box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .slide2Cnt {
      display: flex;
      opacity: 0;

      .slide2CntItem {
        text-align: center;
        margin: 0 4.8vw;

        .downTitle {
          margin-top: 30px;
          height: 28px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
        }

        img {
          width: 229px;
          height: 188px;
        }

        .goDownloads {
          display: flex;
          justify-content: center;
          cursor: pointer;
          margin-top: 18px;
          align-items: center;

          span {
            height: 18px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0091FF;
            line-height: 18px;
          }

          img {
            width: 18px;
            height: 18px;
            transform: translateY(2px);
          }
        }
      }

      img {
        width: 188px;
        height: 188px;
      }
    }

    .slide2Title {
      margin-bottom: 16vh;
      display: flex;
      flex-direction: column;
      opacity: 0;

      img {
        width: 500px;
        height: 58px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pageFull.vue